import {
  curPoints as curPointsSubject,
  forwardsEdgeStartEndIdxs as forwardsEdgeStartEndIdxsSubject,
  forwardsEdgeToUnsortedEdge as forwardsEdgeToUnsortedEdgeSubject,
  logicalEdges as logicalEdgesSubject,
  backwardsEdgeStartEndIdxs as backwardsEdgeStartEndIdxsSubject,
  backwardsEdgeToUnsortedEdge as backwardsEdgeToUnsortedEdgeSubject,
} from "@graphistry/viz/src/client/legacy";

import { wavefrontExpand } from "@graphistry/viz/src/utils/wavefrontExpand";
import {
  ref as $ref,
  atom as $atom,
  pathValue as $value,
  pathInvalidation as $invalidate,
} from "@graphistry/falcor-json-graph";
import { Observable } from "@reactivex/rxjs";
import {
  SET_EXPANDER_OPEN,
  SET_EXPANDER_HOPS,
  SET_EXPANDER_DIRECTION,
  COMMIT_EXPANSION,
} from "@graphistry/viz/src/actions/expander";

const getViewModel = (falcor) =>
  falcor._clone({
    _path: falcor.getPath().slice(0, 4),
  });

export function expander(action$, store) {
  return Observable.merge(
    setExpanderOpen(action$),
    setExpanderHops(action$),
    setExpanderDirection(action$),
    commitExpansion(action$)
  ).ignoreElements();
}

function setExpanderOpen(action$) {
  return action$.ofType(SET_EXPANDER_OPEN).exhaustMap(({ falcor, open, ...rest }) => {
    console.log(SET_EXPANDER_OPEN, { falcor, open, ...rest }, "@reducers/expander");
    return getViewModel(falcor).set($value(`expander.open`, open));
  });
}

function setExpanderHops(action$) {
  return action$.ofType(SET_EXPANDER_HOPS).exhaustMap(({ falcor, hops }) => {
    return getViewModel(falcor).set($value(`expander.hops`, hops));
  });
}

function setExpanderDirection(action$) {
  return action$
    .ofType(SET_EXPANDER_DIRECTION)
    .exhaustMap(({ falcor, direction }) => {
      return getViewModel(falcor).set($value(`expander.direction`, direction));
    });
}

function commitExpansion(action$, store) {
  return action$
    .ofType(COMMIT_EXPANSION)
    .throttleTime(200)
    .withLatestFrom(
      curPointsSubject,
      forwardsEdgeStartEndIdxsSubject,
      forwardsEdgeToUnsortedEdgeSubject,
      logicalEdgesSubject,
      backwardsEdgeStartEndIdxsSubject,
      backwardsEdgeToUnsortedEdgeSubject,
      (
        { falcor, startingPoints, startingEdges, hops, direction },
        curPoints,
        forwardsEdgeStartEndIdxs,
        forwardsEdgeToUnsortedEdge,
        logicalEdges,
        backwardsEdgeStartEndIdxs,
        backwardsEdgeToUnsortedEdge
      ) => {
        const pointsExpanded = [...startingPoints];
        const edgesExpanded = [...startingEdges];

        wavefrontExpand({
          highlightedNodeIndices: pointsExpanded,
          highlightedEdgeIndices: edgesExpanded,
          neighborhoodHighlightHops: hops,
          neighborhoodHighlight: direction,
          forwardsEdgeStartEndIdxs,
          backwardsEdgeStartEndIdxs,
          forwardsEdgeToUnsortedEdge,
          backwardsEdgeToUnsortedEdge,
          logicalEdges,
          numPoints: curPoints.length,
        });

        const viewModel = getViewModel(falcor);
        return viewModel.set({
          invalidate: [`selection.labels['point', 'edge']`],
          json: {
            highlight: {
              darken: false,
              point: $atom([]),
              edge: $atom([]),
            },
            selection: {
              point: $atom(pointsExpanded),
              edge: $atom(edgesExpanded),
            },
            ...(pointsExpanded.length === 1 && edgesExpanded.length === 0
              ? {
                  labels: {
                    selection: $ref(
                      viewModel
                        .getPath()
                        .concat('labelsByType', 'point', pointsExpanded[0])
                    ),
                  },
                }
              : {}),
          },
        });
      }
    )
    .concatAll();
}
